import capitalize from '@/commons/formatters/capitalize';
import { paymentMethods } from '@/apps/payin/paymentLink/constants/paymentMethods';

export const formatedPaymentMethods = methods =>
  methods.map(paymentMethod => capitalize(paymentMethods[paymentMethod])).join(', ');
